module.exports = __webpack_public_path__ + "assets/webgl/lens_reflection.3685b26a.jpg";